function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Interact-2",
  "data-name": "Interact"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path",
  d: "M1.343,8.985a1,1,0,0,0,.869-1.147A5.124,5.124,0,0,1,7.5,1.985a5.125,5.125,0,0,1,5.29,5.841,1,1,0,0,0,.872,1.145,1.061,1.061,0,0,0,1.23-.812C15.671,3.894,12.136,0,7.5,0S-.683,3.894.111,8.176A1.061,1.061,0,0,0,1.343,8.985Z",
  transform: "translate(2)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Shape",
  d: "M19.076,30H11.057a4.911,4.911,0,0,1-3.592-1.576L.815,21.238a3.018,3.018,0,0,1,.16-4.285A2.9,2.9,0,0,1,2.939,16.2a3.008,3.008,0,0,1,2.181.94l1.157,1.228V2.993A2.979,2.979,0,0,1,9.235,0H9.32A3.021,3.021,0,0,1,12.2,3.035V9.146a2.909,2.909,0,0,1,.967-.166A2.94,2.94,0,0,1,15.8,10.619a2.885,2.885,0,0,1,1.3-.309,2.944,2.944,0,0,1,2.637,1.64,2.884,2.884,0,0,1,1.3-.312,2.981,2.981,0,0,1,2.959,3V25.011A4.963,4.963,0,0,1,19.076,30ZM2.941,18.187a.951.951,0,0,0-.645.246,1.007,1.007,0,0,0-.053,1.431l5.8,6.268.106.114.752.812A2.947,2.947,0,0,0,11.057,28h8.019a2.978,2.978,0,0,0,2.955-2.993V14.634a.985.985,0,1,0-1.969,0v.333a.985.985,0,1,1-1.97,0V13.3a.985.985,0,1,0-1.969,0v1.663a.985.985,0,1,1-1.97,0V11.974a.984.984,0,0,0-1.951-.19v3.183a.992.992,0,0,1-.984,1H11.2a.972.972,0,0,1-.7-.293,1,1,0,0,1-.288-.7c0-2.513,0-3.066.007-3.706.005-.889.012-1.9.012-8.226A1.023,1.023,0,0,0,9.267,2H9.238a1,1,0,0,0-.991,1V20.855a.986.986,0,0,1-.994,1,.958.958,0,0,1-.7-.31L3.7,18.516A1.044,1.044,0,0,0,2.941,18.187Z",
  transform: "translate(0 4)"
}));

var SvgIconInteract = function SvgIconInteract(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Interact",
    width: 24,
    height: 34,
    viewBox: "0 0 24 34",
    fill: "#3aabf2",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconInteract, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-interact.2d82c59a.svg";
export { ForwardRef as ReactComponent };